








































































































import { Component, Vue } from "vue-property-decorator";
import { DataOptions, DataTableHeader } from "vuetify";
import { CustomersApi } from "../../../apis/invoke/customers-api";
import { CustomerModel, GetCustomersResponse } from "../../../apis";
import config from "../../../config";
import { IAction } from "../common/CommonTypes";
import MoreVertBtn from "../common/MoreVertBtn.vue";
import ConfirmDialog from "../user-management/ConfirmDialog.vue";
import { ACTION } from "./index";

@Component({
  components: {
    MoreVertBtn,
    ConfirmDialog,
  },
})
export default class AdminCustomerList extends Vue {
  pagingOption: DataOptions | null = null;
  totalItems = 0;

  selectedPermisstionId = "";
  selectCountry = "";
  selectStatus = "Active";
  searchText = "";
  countries = config.settings.country;
  get itemsCountry() {
    return this.countries;
  }
  get itemsStatus() {
    return [
      { value: "Active", text: this.$t("locationColumn.status.Active") },
      { value: "Inactive", text: this.$t("locationColumn.status.Inactive") },
    ];
  }

  customerResponse: GetCustomersResponse;
  items: CustomerModel[] = [];
  selectedCustomer = {} as CustomerModel;
  showConfirmDialog = false;
  confirmContent = "";
  get actions(): IAction[] {
    return [
      {
        titleName: this.$t("customer.view"),
        action: ACTION.VIEW_CUSTOMERS,
      },
      {
        titleName: this.$t("customer.edit"),
        action: ACTION.EDIT_CUSTOMER,
        permission: { context: "CUSTOMER_MANAGEMENT", action: "update" },
      },
      {
        titleName: this.$t("customer.disable"),
        action: ACTION.DISABLE_NAME,
        titleStyle: "color: red",
        permission: { context: "CUSTOMER_MANAGEMENT|ACTIVATE_DEACTIVATE", action: "update" },
      },
      {
        titleName: this.$t("customer.enable"),
        action: ACTION.ENABLE_NAME,
        titleStyle: "color: green",
        permission: { context: "CUSTOMER_MANAGEMENT", action: "update" },
      },
    ];
  }

  get ROW_PER_PAGES() {
    return this.$util.getConfig().settings.rowPerPage;
  }

  checkStatusAction(status: string) {
    if (status == "Inactive")
      return this.actions.filter((val) => val.action != ACTION.DISABLE_NAME);
    return this.actions.filter((val) => val.action != ACTION.ENABLE_NAME);
  }

  get headers() {
    return [
      {
        text: this.$t("text.companyName"),
        align: "start",
        value: "companyName",
        class: ["tw-p-4", "tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.email"),
        value: "email",
        class: ["tw-p-4", "tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.phoneNumber"),
        value: "phoneNumber",
        class: ["tw-p-4", "tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.address"),
        value: "address",
        class: ["tw-p-4", "tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.country"),
        value: "country",
        class: ["tw-p-4", "tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.status"),
        value: "status",
        class: ["tw-p-4", "tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("locationColumn.createdDate"),
        value: "createdDate",
        class: ["tw-p-4", "tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.action"),
        value: "action",
        // class: ["tw-p-4", "tw-whitespace-no-wrap", "column-sticky"],
        class: ["tw-p-4", "tw-whitespace-no-wrap"],
        // cellClass: ["column-sticky"],
      },
    ] as DataTableHeader[];
  }

  onPagingOption() {
    this.onSearch();
  }

  getColor(status: string) {
    if (status == "Inactive") return "#8A8A8A";
    else if (status == "Active") return "#00B162";
  }

  onSelectedPermission(item, action): void {
    this.selectedCustomer = { ...item };
    switch (action) {
      case ACTION.VIEW_CUSTOMERS: {
        this.navigateDetail();
        break;
      }
      case ACTION.EDIT_CUSTOMER: {
        this.navigateEdit();
        break;
      }
      case ACTION.DISABLE_NAME: {
        this.onDisableCustomer();
        break;
      }
      case ACTION.ENABLE_NAME: {
        this.changeStatusEnable();
        break;
      }
      default: {
        break;
      }
    }
  }

  onOkConfirmDialog() {
    this.changeStatusEnable();
  }

  onDisableCustomer() {
    this.showConfirmDialog = true;
    this.confirmContent = `${this.$t(
      "dialog.confirmCustomer.contentDisable"
    )} ?`;
  }

  navigateDetail() {
    const id = this.selectedCustomer.id;
    this.selectedPermisstionId = id;
    return this.$router.push({
      name: "customer-detail",
      params: { id },
    });
  }

  navigateEdit() {
    const id = this.selectedCustomer.id;
    this.selectedPermisstionId = id;
    return this.$router.push({
      name: "customer-edit",
      params: { id },
    });
  }

  async changeStatusEnable() {
    await this.updateCustomerHandle();
  }

  getChangeStatus(status: string) {
    if (status == "Inactive") return (status = "Active");
    if (status == "Active") return (status = "Inactive");
  }

  async updateCustomerHandle() {
    this.$util.showLoading();
    const statusSelect = this.selectedCustomer.status;
    if (statusSelect == "Active") {
      try {
        await new CustomersApi().disableCustomer({
          id: this.selectedCustomer.id,
        });
        this.showConfirmDialog = false;
        this.onSearch();
      } catch (error) {
        this.$util.showError(error);
      } finally {
        this.$util.hideLoading();
      }
    }
    if (statusSelect == "Inactive") {
      try {
        await new CustomersApi().enableCustomer({
          id: this.selectedCustomer.id,
        });
        this.onSearch();
      } catch (error) {
        this.$util.showError(error);
      } finally {
        this.$util.hideLoading();
      }
    }
  }

  async onSearch() {
    this.$util.showLoading();
    try {
      const rs = await new CustomersApi().getCustomersByKeywordCountryStatus({
        keyword: this.searchText || "",
        country: this.selectCountry || "",
        status: this.selectStatus || "",
        page: this.pagingOption.page,
        limit: this.pagingOption.itemsPerPage,
        orderBy:
          this.pagingOption.sortBy.length > 0
            ? this.pagingOption.sortBy[0]
            : "",
        orderDesc:
          this.pagingOption.sortDesc.length > 0
            ? "" + this.pagingOption.sortDesc[0]
            : "",
      });
      this.totalItems = rs.data.count;
      this.items = rs.data.data;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }
}
